import * as React from "react";
import { useNetworkStatus } from "hooks/use-network-status";
import { Container, Title, SubTitle } from "./offline-banner-style";

const OfflineBanner: React.FunctionComponent = () => {
    const onLine = useNetworkStatus();

    if (onLine) {
        return null;
    }

    return (
        <Container>
            <Title>You are offline.</Title>
            <SubTitle>You can view this app, but not make changes.</SubTitle>
        </Container>
    );
};

export default OfflineBanner;
